import { Component, EventEmitter, Output } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from '@ag-grid-community/core';

export interface CustomSliderToggleCellRendererParams extends ICellRendererParams {
  onchange: (params) => void;
}

@Component({
  standalone: false,
  selector: 'custom-slider-toggle-cell-renderer',
  templateUrl: './custom-slider-toggle-cell-renderer.component.html',
  styleUrls: ['./custom-slider-toggle-cell-renderer.component.scss']
})
export class CustomSliderToggleCellRendererComponent implements ICellRendererAngularComp {
  agParams!: CustomSliderToggleCellRendererParams & IHeaderParams;
  value: boolean;

  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params: any): void {
    this.agParams = params;
  }

  sliderToggleStateChanged() {
    event.preventDefault();
    event.stopPropagation();
    this.onslideToggleStateChange(this.agParams);
  }

  onslideToggleStateChange(params) {
    if (this.agParams.onchange) {
      this.agParams.onchange(this.agParams);
    }
    params.colDef.headerComponentParams.headerCheckboxChecked = params.headerCheckboxChecked;
    params.colDef.headerComponentParams.headerCheckboxhasIndeterminateState = params.headerCheckboxhasIndeterminateState;
    params.api.refreshHeader();
  }
}
